module.exports = __webpack_public_path__ + "img/home_1.3ba17f6b.png";